import { createTheme, loadTheme } from "@fluentui/react";

const poppinsStack = '"Poppins", sans-serif';

const myTheme = createTheme({
    defaultFontStyle: {
        fontFamily: poppinsStack,
    },
    palette: {

        themePrimary: "#4c8d6a",
        // themeLighterAlt: "#f6faf8",
        // themeLighter: "#dbede3",
        // themeLight: "#beddcc",
        // themeTertiary: "#87ba9f",
        // themeSecondary: "#5c9a79",
        themeDarkAlt: "#447e5f",
        themeDark: "#3a6b50",
        // themeDarker: "#2a4f3b",
        // neutralLighterAlt: "#faf9f8",
        // neutralLighter: "#F0F0F0",
        // neutralLight: "#E2EFDF",
        // neutralQuaternaryAlt: "#e1dfdd",
        // neutralQuaternary: "#d0d0d0",
        // neutralTertiaryAlt: "#c8c6c4",
        // neutralTertiary: "#a19f9d",
        // neutralSecondary: "#A7A7A7",
        // neutralPrimaryAlt: "red",
        neutralDark: "#201f1e",
        // black: "#000000",
        // white: "#ffffff"
    }
});

loadTheme(myTheme);

export default myTheme;
